import { Injectable, Injector, NgZone } from '@angular/core';
import { Location } from '../models/company/dto/location';
import { ModalLocationPicker } from '../modals/modal-location-picker';
import { LocationDomainModel } from '../domainModels/location-domain-model';
import { BaseService } from '@mobilefirstdev/base-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationService } from './navigation.service';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

/**
 * A service was needed, because adding this code to the location domain model creates a circular dependency.
 */
@Injectable() // Provided by Logged In Scope
export class RestrictedLocationMismatchService extends BaseService {
  constructor(
    private locationDomainModel: LocationDomainModel,
    private ngZone: NgZone,
    private ngbModal: NgbModal,
    private injector: Injector,
    private navigationService: NavigationService
  ) {
    super();
    this.listenForRestrictedLocationMismatches();
  }

  private mismatchLocationModalOpen = false;

  public restrictedLocationMismatch$ = combineLatest([
    this.locationDomainModel.restrictedToLocationIds$.notNull$(),
    this.locationDomainModel.locationId$.notNull$()
  ]).pipe(
    map(([restrictedToLocationIds, locationId]) => {
      if (!restrictedToLocationIds?.length) return false;
      return !restrictedToLocationIds.includes(locationId);
    }),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  private listenForRestrictedLocationMismatches() {
    this.restrictedLocationMismatch$.subscribeWhileAlive({
      owner: this,
      next: mismatch => {
        if (mismatch && !this.mismatchLocationModalOpen) {
          this.openLocationPickerModal();
        }
      }
    });
  }

  private openLocationPickerModal(): void {
    this.mismatchLocationModalOpen = true;
    this.navigationService.home();
    const onClose = ([activeLocation, _]: [Location, boolean]) => {
      this.mismatchLocationModalOpen = false;
      if (activeLocation) {
        this.locationDomainModel.connectToCurrentLocation(activeLocation);
      }
    };
    const onError = () => {
      this.mismatchLocationModalOpen = false;
      console.error(`LocationPickerModalComponent Force Closed. Re-opening modal.`);
      this.openLocationPickerModal();
    };
    ModalLocationPicker.open(this.ngZone, this.ngbModal, this.injector, onClose, onError, true);
  }
}
